module.exports = __webpack_public_path__ + "static/media/motoamerica@2x.78f8afbf.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/motoamerica@2x.png
// module id = 1018
// module chunks = 0